import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { ChatWidget } from './ChatWidget';
import { Toaster } from '@/components/ui/sonner';
import MobileBottomNav from './MobileBottomNav';
import { HreflangLinks } from '@/components/seo/HreflangLinks';
import { getExplicitLocaleFromPathname } from '@/lib/intl-seo';
import { languages } from '@/lib/i18n';

const supported = new Set(languages.map((l) => l.code));

export const Layout = ({ children }) => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const isCheckoutFlow = location.pathname === '/checkout' || location.pathname === '/checkout/cancel';

  // Yalnızca pathname değişince URL'deki locale ile senkronize et.
  useEffect(() => {
    const raw = getExplicitLocaleFromPathname(location.pathname);
    if (!raw || !supported.has(raw)) return;
    i18n.changeLanguage(raw);
    document.documentElement.lang = raw;
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col min-w-0 overflow-x-hidden">
      <HreflangLinks />
      <Navbar />
      <main className={`flex-1 min-w-0 ${isCheckoutFlow ? 'pb-0' : 'pb-14 sm:pb-0'}`}>{children}</main>
      {!isCheckoutFlow && <Footer />}
      {!isCheckoutFlow && <ChatWidget />}
      {!isCheckoutFlow && <MobileBottomNav />}
      <Toaster position="top-right" />
    </div>
  );
};
